import { jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import {
  OrderNumber,
  OrderStatus,
  RefundSummaryResponse,
} from '@web/shared/module/shop';
import { AdminSubscriptionOrderType } from '../../enums/admin-subscription-order-type';

@jsonObject
export class AdminSubscriptionOrderCollectionItemResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly number!: OrderNumber;

  @jsonMember(String)
  public readonly status!: OrderStatus;

  @jsonMember(Number)
  public readonly totalItems!: number;

  @jsonMember(Number)
  public readonly totalPrice!: number;

  @jsonMember(RefundSummaryResponse)
  public readonly refundSummary?: Nillable<RefundSummaryResponse>;

  @jsonMember(Date)
  public readonly createdAt!: Date;

  @jsonMember(String)
  public readonly type!: AdminSubscriptionOrderType;
}
